import type { RandomInt } from './ids.js';
import { randomInt } from './ids.js';

const ADJECTIVES = [
  'Amber',
  'Brisk',
  'Calm',
  'Clever',
  'Copper',
  'Cosmic',
  'Crimson',
  'Crystal',
  'Daring',
  'Dawn',
  'Drift',
  'Ember',
  'Falcon',
  'Gentle',
  'Glacier',
  'Golden',
  'Harbor',
  'Hidden',
  'Indigo',
  'Ivory',
  'Jade',
  'Lively',
  'Lunar',
  'Maple',
  'Mellow',
  'Midnight',
  'Misty',
  'Nimble',
  'Noble',
  'Olive',
  'Onyx',
  'Quiet',
  'Rapid',
  'Rustic',
  'Sable',
  'Saffron',
  'Silent',
  'Silver',
  'Solar',
  'Sonic',
  'Swift',
  'Tidal',
  'Velvet',
  'Vivid',
  'Wandering',
  'Wild',
  'Willow',
  'Zephyr',
] as const;

const NOUNS = [
  'Otter',
  'Falcon',
  'Heron',
  'Lynx',
  'Fox',
  'Panda',
  'Crane',
  'Wolf',
  'Robin',
  'Badger',
  'Beacon',
  'Comet',
  'Cove',
  'Cypress',
  'Delta',
  'Driftwood',
  'Echo',
  'Fern',
  'Finch',
  'Glade',
  'Harbor',
  'Island',
  'Kite',
  'Lagoon',
  'Lantern',
  'Lark',
  'Meadow',
  'Meteor',
  'Moth',
  'Orbit',
  'Pebble',
  'Pine',
  'Raven',
  'Reef',
  'River',
  'Sparrow',
  'Summit',
  'Thistle',
  'Tundra',
  'Vale',
  'Willow',
] as const;

/**
 * Generate a friendly, non-identifying device name.
 * We deliberately do not fingerprint the browser or device.
 */
export function generateDeviceName(nextInt: RandomInt = randomInt): string {
  const adjective = ADJECTIVES[nextInt(ADJECTIVES.length)] ?? 'Quiet';
  const noun = NOUNS[nextInt(NOUNS.length)] ?? 'Otter';
  const number = nextInt(90) + 10;
  return `${adjective} ${noun} ${number}`;
}

export const DEVICE_NAME_ADJECTIVES = ADJECTIVES;
export const DEVICE_NAME_NOUNS = NOUNS;
